var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidanceRampUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M23 23H1v-1c14-3.228 21.5-9 21.5-9h.5zM13 8.247L.5 15.5M13 8.246c-.498.29-.944.95-1.274 1.559a7.972 7.972 0 0 0-.856 2.622c-.106.712-.155 1.514.068 1.902M13 8.246c-.498.29-1.29.348-1.98.33a7.87 7.87 0 0 1-2.687-.566C7.666 7.747 6.95 7.388 6.728 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceRampUpArrow);
export default __webpack_public_path__ + "static/media/guidance--ramp-up-arrow.d59b4985bd519bbe86ee8c6c6b975205.svg";
export { ForwardRef as ReactComponent };